<template>
  <div class="review" :class="{ centered: twoColumn }">
    <div class="item-stars">
      <span v-for="i in 5" :key="i" class="starWrapper">
        <!-- 赤い星 -->
        <template v-if="i <= onesPlace">
          <svg
            class="star"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12.52 12"
            width="12.52"
            height="12"
          >
            <defs></defs>
            <path
              d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"
            />
          </svg>
        </template>
        <!-- 小数点部分の星 -->
        <template v-else-if="i === onesPlace + 1">
          <svg
            class="star inactive"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12.52 12"
            width="12.52"
            height="12"
          >
            <defs></defs>
            <path
              d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"
            />
          </svg>
          <span :class="`floatingWrapper-${firstDecimalPoint * 10}`">
            <svg
              class="star float"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12.52 12"
              width="12.52"
              height="12"
            >
              <defs></defs>
              <path
                d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"
              />
            </svg>
          </span>
        </template>
        <!-- グレーの星 -->
        <template v-else>
          <svg
            class="star inactive"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12.52 12"
            width="12.52"
            height="12"
          >
            <defs></defs>
            <path
              d="M12.49,4.53a.66.66,0,0,0-.57-.45L8.3,3.75,6.87.4A.67.67,0,0,0,6,.05.7.7,0,0,0,5.65.4L4.22,3.75.6,4.08A.67.67,0,0,0,0,4.8a.68.68,0,0,0,.23.44L3,7.64l-.81,3.55a.67.67,0,0,0,.5.8.64.64,0,0,0,.49-.08l3.12-1.86L9.38,11.9a.66.66,0,0,0,.91-.23.64.64,0,0,0,.08-.49L9.56,7.64l2.74-2.4A.69.69,0,0,0,12.49,4.53Z"
            />
          </svg>
        </template>
      </span>
    </div>
    <div class="review-text">
      （<a
        :href="`https://www.shiseido.co.jp/wpmember/review/products/list.php?pl_c_cd=${poolCode}`"
        target="_blank"
        class="review-link"
        @click="handleClick"
        >{{ totalCount }}レビュー</a
      >）
    </div>
  </div>
</template>
<script>
import fetchJsonp from "fetch-jsonp";
import { mapGetters } from "vuex";
import { adobeClickEvent } from "../../modules/analytics";

export default {
  name: "Review",
  props: {
    id: {
      type: String,
      default: "",
    },
    poolCode: {
      type: String,
      default: "",
    },
    twoColumn: {
      type: Boolean,
      default: false,
    },
    analyticsPrefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      timeoutId: null,
      totalCount: "-",
      totalEvaluation: 0,
    };
  },
  computed: {
    ...mapGetters("product", ["review"]),
    onesPlace() {
      return Math.floor(this.totalEvaluation);
    },
    firstDecimalPoint() {
      return Math.round((this.totalEvaluation - this.onesPlace) * 10) / 10;
    },
  },
  methods: {
    analyze(eventId, url) {
      adobeClickEvent(`${this.analyticsPrefix}_${eventId}`, url);
    },
    handleClick(e) {
      const url = e.currentTarget.href;
      this.analyze(this.poolCode, url);
    },
  },
  async created() {
    const reviewData = this.review.find(
      (data) => data.poolId === this.poolCode
    );

    if (reviewData) {
      this.totalCount = reviewData.totalCount;
      this.totalEvaluation = reviewData.totalEvaluation;
    } else {
      this.timeoutId = setTimeout(async () => {
        const params = new URLSearchParams({
          pl_c_cd: this.poolCode,
          sort: "01",
          list_count: 1,
          page_index: 1,
        });

        this.timeoutId = null;
        fetchJsonp(
          `https://www.shiseido.co.jp/wpmember/review/products/api/getReviewList.php?${params}`
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            const status = json.status;
            if (!status) return;
            const { total_count, total_evaluation } = json;
            this.totalCount = total_count;
            this.totalEvaluation = total_evaluation;
            this.$store.dispatch("product/setReviewData", {
              poolId: this.poolCode,
              totalCount: total_count,
              totalEvaluation: total_evaluation,
            });
          })
          .catch(() =>
            //ex
            {
              // console.log("parsing failed", ex);
            }
          );
      }, 3000);
    }
  },
  destroyed() {
    if (this.timeoutId) clearTimeout(this.timeoutId);
  },
};
</script>
<style lang="scss" scoped>
.review {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  &.centered {
    justify-content: center;
  }

  .item-stars {
    display: flex;
    align-items: center;
    margin-right: 4px;
    /* padding: 2px 0; */
  }
  .starWrapper {
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;

    & + .starWrapper {
      margin-left: 5px;
    }
  }

  @for $i from 0 through 10 {
    .floatingWrapper-#{$i} {
      height: 12px;
      position: absolute;
      top: 0;
      left: 0;
      width: $i * 10%;
      overflow: hidden;
    }
  }

  .star {
    fill: $main-red;
    width: 13px;
    height: 12px;

    &.inactive {
      fill: #cccccc;
    }

    &.float {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .review-text {
    font-size: 12px;
    & > a {
      opacity: 1;
      transition: opacity 0.3s $easing-color;
    }

    @media (hover: hover) {
      & > a {
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }

  .review-link {
    color: $main-red;
    text-decoration: underline currentColor;
  }

  @include media() {
    .starWrapper {
      & + .starWrapper {
        margin-left: vw(4.2);
      }
    }

    @for $i from 0 through 10 {
      .floatingWrapper-#{$i} {
        height: vw(10);
      }
    }
    .star {
      width: vw(10.44);
      height: vw(10);
    }
    .review-text {
      font-size: vw(10);
    }

    &.centered {
      .review-text {
        margin-top: vw(5);
      }
    }
  }
}
</style>
